import { Endpoint } from '../endpoint';
import { StatResponse, StatId } from '@business/entities/stat_collection';

export function fetchStatCollections() {
  return Endpoint.get<StatResponse[]>(`@makh/stat-collection`);
}

export function fetchStatCollection(id: StatId) {
  return Endpoint.get<StatResponse>(`@makh/stat-collection/stat-collection/${id}`);
}

export function createStatCollection(stat: Partial<StatResponse>) {
  return Endpoint.post<StatResponse>(`@makh/stat-collection/create`, { data: { ...stat } });
}

export function updateStatCollection(id: StatId, stat: Partial<StatResponse>) {
  return Endpoint.patch<StatResponse>(`@makh/stat-collection/${id}`, { data: { ...stat } });
}

export function deleteStatCollection(statId: StatId) {
  return Endpoint.delete<void>(`@makh/stat-collection/${statId}`);
}

export function sendEmail(statId: StatId, stat: Partial<StatResponse>) {
  return Endpoint.post<StatResponse>(`@makh/stat-collection/send-email/${statId}`, { data: { ...stat } });
}

export function updateReport(statId: StatId, stat: Partial<StatResponse>) {
  return Endpoint.post<StatResponse>(`@makh/stat-collection/update-report/${statId}`, { data: { ...stat } });
}
